export const defaultBom = [
  [
    'Item Number',
    'Reference Designator',
    'Quantity Per Board',
    'Manufacturer Part Number',
  ],
  ['1', 'C1', '1', 'CL05C220JB5NGNC'],
  ['2', 'FB4,FB2,FB3,FB1', '4', 'BLM18PG471SN1D'],
  ['3', 'U1,U2', '2', 'MAX98357AETE+T'],
  ['4', 'C5,C7,C6,C8', '4', 'CGA3E2C0G1H221J080AA'],
  ['5', 'J6', '1', 'BM05B-GHS-TBT'],
  ['6', 'J4,J5', '2', '5025840360'],
  ['7', 'U3', '1', 'BABEL-B'],
];
